import React, { useRef } from 'react';

const DmReciveModeSelect = ({ value, onChange }) => {
  // Save the initial custom option (if any) in a ref so it doesn’t change on re-render.
  const initialCustomOption = useRef(value !== "WbAmr" ? value : null);
  // Always include "C1T1"; add the custom option only if it exists.
  const options = ["AmrWb","WbAmr","Wb","Amr"];
  const optionLabels = {
    "WbAmr": "Walk by (otherwise AMR)",
    "Wb": "Walk by only",
    "AmrWb": "AMR (Walk by fallback)",
    "Amr": "AMR only"
  }

  if (initialCustomOption.current) {
    options.push(initialCustomOption.current);
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: '200px' }} // adjust style as needed for a "small" menu
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {optionLabels[option]}
        </option>
      ))}
    </select>
  );
};


export default DmReciveModeSelect;
